export interface InsidePage {
  src: string
  alt: string
}

/** The five real interior pages of the product — do not replace with mockups. */
export const insidePages: InsidePage[] = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/oAW5uUe9bBS26WwawYkLuk/Captura-de-pantalla-2026-10-11-a-la_s_-4.19.55_p._m..png',
    alt: 'Interior page: When leaves turn pale without a clear vein pattern — uniform chlorosis comparison table',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/9eT5CkE816BCRfz9Lm2ViC/Captura-de-pantalla-2026-10-11-a-la_s_-4.19.34_p._m..png',
    alt: 'Interior page: Sulfur vs nitrogen deficiency — pale young growth and general chlorosis in cereals and brassicas',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/4YkWWirqGg5obRREpBSeV9/Captura-de-pantalla-2026-10-11-a-la_s_-4.18.59_p._m..png',
    alt: 'Interior page: Identify the symptom type before the possible cause — six leaf symptom categories',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/2ExXqeSnqgWq5yCYsWEvk8/Captura-de-pantalla-2026-10-11-a-la_s_-4.18.44_p._m..png',
    alt: 'Interior page: Leaf position is a critical diagnostic clue — mobile vs immobile nutrients',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/oAAFJCdGjiTiLXNbBX3BVe/Captura-de-pantalla-2026-10-11-a-la_s_-4.19.16_p._m..png',
    alt: 'Interior page: Nitrogen deficiency — general chlorosis and reduced growth in corn',
  },
]
